/**
 * 🤿 DiveFx — the underwater screen state for wreck diving (Onda diving-polish).
 *
 * PURE PRESENTATION, DOM-only (the combatfx "screen state" overlay pattern — zero WebGL cost, one composited
 * layer): a teal depth vignette breathes in from the edges while the captain is below, and a faint band of
 * caustic light-shafts sways overhead (screen blend, so it reads as sun rays through water, day or night).
 * main.ts flips it from the authoritative `self.activity` (3 = diving); mechanics/odds/timers are untouched.
 * Mobile-first: pure CSS transitions/keyframes, no per-frame JS.
 */
export class DiveFx {
  private readonly el: HTMLDivElement;
  private on = false;

  constructor() {
    const d = document.createElement('div');
    d.id = 'divefx';
    d.innerHTML = '<div class="df-depth"></div><div class="df-rays"></div>';
    const st = document.createElement('style');
    st.textContent = `
#divefx{position:fixed;inset:0;pointer-events:none;z-index:8;opacity:0;transition:opacity .8s ease;}
#divefx.on{opacity:1;}
#divefx .df-depth{position:absolute;inset:0;background:radial-gradient(120% 90% at 50% 58%, rgba(2,40,54,0) 38%, rgba(2,40,54,.30) 68%, rgba(1,20,30,.6) 100%);}
#divefx .df-rays{position:absolute;inset:-12% -8%;mix-blend-mode:screen;opacity:.85;
  background:linear-gradient(101deg, transparent 12%, rgba(120,220,235,.10) 17%, transparent 24%,
    transparent 38%, rgba(120,220,235,.07) 45%, transparent 52%,
    transparent 70%, rgba(120,220,235,.09) 76%, transparent 84%);
  animation:dfSway 7s ease-in-out infinite alternate;}
@keyframes dfSway{from{transform:translateX(-2.5%) skewX(-1.5deg);}to{transform:translateX(2.5%) skewX(1.5deg);}}
`;
    document.head.appendChild(st);
    document.body.appendChild(d);
    this.el = d;
  }

  /** Flip the underwater overlay (idempotent; CSS eases the transition both ways). */
  set(active: boolean): void {
    if (active === this.on) return;
    this.on = active;
    this.el.classList.toggle('on', active);
  }
}
